import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
    //     history: JSON.parse(localStorage.getItem('pathHistory') || '[]')
    //         .map(item => ({
    //         path: item.path,
    //         name: item.name || item.path,
    //         timestamp: item.timestamp || Date.now()
    //         }))
    },
    mutations: {
    //     ADD_PATH(state, { path, name }) {  
    //         // 检查路径是否已存在  
    //         const exists = state.history.some(item => item.path === path);  
    //         if (!exists) {  
    //             state.history.push({  
    //                 path: path,  
    //                 name: name || '未知页面',  
    //                 timestamp: Date.now()  
    //             });  
    //             localStorage.setItem('pathHistory', JSON.stringify(state.history));  
    //         }  
    //       },  
    //     RESET_HISTORY(state, currentRoute) {
    //         state.history = [{
    //             path: currentRoute.path,
    //             name: currentRoute.name || currentRoute.path,
    //             timestamp: Date.now()
    //         }]
    //         localStorage.setItem('pathHistory', JSON.stringify(state.history))
    //     },
    //     REMOVE_PATH(state, index) {
    //         state.history.splice(index, 1);
    //         localStorage.setItem('pathHistory', JSON.stringify(state.history));
    //     }
    },
    getters: {
    //     historyList: state => state.history
    }
  })